/* eslint no-param-reassign: ["error", { "props": false }] */
const TABSBAR_ADD_TAB = 'TABSBAR_ADD_TAB';
const TABSBAR_UPDATE_TAB = 'TABSBAR_UPDATE_TAB';
const TABSBAR_REMOVE_TAB = 'TABSBAR_REMOVE_TAB';
const TABSBAR_REMOVE_TABS_ALL = 'TABSBAR_REMOVE_TABS_ALL';
const TABSBAR_REMOVE_TABS_OTHER = 'TABSBAR_REMOVE_TABS_OTHER';

const tabsBarState = () => ({
  tabs: [],
});

const tabsBarModule = {
  namespaced: true,
  state: tabsBarState,
  getters: {
  },
  mutations: {
    [TABSBAR_ADD_TAB]({ tabs }, tab) {
      tabs.push(tab);
    },
    [TABSBAR_UPDATE_TAB]({ tabs }, { index, tab }) {
      tabs.splice(index, 1, tab);
    },
    [TABSBAR_REMOVE_TAB]({ tabs }, tab) {
      const index = tabs.findIndex(t => t.key === tab.key);
      if (index > -1) tabs.splice(index, 1);
    },
    [TABSBAR_REMOVE_TABS_OTHER](state, tab) {
      const keepTab = state.tabs.find(t => t.key === tab.key);
      if (keepTab) state.tabs = [keepTab];
    },
    [TABSBAR_REMOVE_TABS_ALL](state) {
      state.tabs = [];
    },
  },
  actions: {
    addOrUpdateTab({ commit, state: { tabs } }, tab) {
      const index = tabs.findIndex(t => t.key === tab.key);
      if (index > -1) commit(TABSBAR_UPDATE_TAB, { index, tab });
      else commit(TABSBAR_ADD_TAB, tab);
    },
    updateTab({ commit, state: { tabs } }, tab) {
      const index = tabs.findIndex(t => t.key === tab.key);
      if (index > -1) {
        const oldTab = tabs[index];
        commit(TABSBAR_UPDATE_TAB, { index, tab: { ...oldTab, ...tab } });
      }
    },
    removeTab({ commit }, tab) {
      commit(TABSBAR_REMOVE_TAB, tab);
    },
    removeTabsOther({ commit }, tab) {
      commit(TABSBAR_REMOVE_TABS_OTHER, tab);
    },
    removeTabsAll({ commit }) {
      commit(TABSBAR_REMOVE_TABS_ALL);
    },
  },
};


export default {
  namespaced: true,
  modules: {
    TabsBar: tabsBarModule,
  },
};
